import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import { generateArrayOfNumbers } from "shared/functions";

export const HierarchyLoader = () => {
    const { gray100 } = colors;

    const arrayOfNumbers = generateArrayOfNumbers(3);

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                rowGap: "4px",
                marginTop: "8px",
                overflowX: "auto"
            })}
        >
            {arrayOfNumbers.map((item, i) => {
                const marginLeft = 28 * i;

                return (
                    <Skeleton
                        key={item}
                        variant="rectangular"
                        width={286}
                        height={24}
                        css={css({
                            background: gray100,
                            borderRadius: "12px",
                            marginLeft: `${marginLeft}px`
                        })}
                    />
                );
            })}
        </div>
    );
};
